import { render, staticRenderFns } from "./superAdminInviteUserModel.vue?vue&type=template&id=820bafd2&"
import script from "./superAdminInviteUserModel.vue?vue&type=script&lang=js&"
export * from "./superAdminInviteUserModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports